import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Heading } from "@lmig/lmds-react";
import shuffle from '@lmig/dotcom-aspect-helpers/shuffle';
import css from 'styled-jsx/css';
import WrapperSizeable from "../Utility/WrapperSizeable";
import AgentListCard from '../Agent/AgentListCard';

const AssociateCards = ({
  associates: _associates,
  state
}) => {
  const [associates, setAssociates] = useState([]);
  const { className: headingClass, styles: headingStyles } = css.resolve`
    @import './global-styles/tokens';
    *{
      color: #1a1446;
      font-size: 1.5rem;
      line-height: 1.33;
      margin: 1rem 0 2rem 0;
      display: block;

      @media screen and (min-width: $lm-breakpoint-md-min) {
        font-size: 2rem;
        line-height: 1.25;
      }
    }
  `;
  const { className: associateClass, styles: associateStyles } = css.resolve`
    *{
      margin-bottom: 1rem;
      width: 100%;
      max-width: 23rem;
    }
  `;

  useEffect(() => {
    setAssociates(shuffle(_associates));
  }, [_associates]);

  return !!associates.length &&
    (<WrapperSizeable padding="1rem" margin={0} backgroundColor="lightLibertyTeal">
      <div className="associateCardWrapper">
        <span id="associatesInOffice" />
        <Heading type="h2-bold" className={headingClass}>My team</Heading>
        <div className="associates">{associates.map(associate => <AgentListCard key={associate.displayName} className={associateClass} agent={associate} stateName={state} cardView showReviews={false} linkedName={false} isAssociate />)}</div>
        {headingStyles}
        {associateStyles}
        <style jsx>{`
        @import './global-styles/tokens';
        .associateCardWrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: 80rem;
        }
        .associates {
          width: 100%;
          display: flex;
          flex-flow: row wrap;
          column-gap: 1.5rem;
          justify-content: center;
          margin-bottom: -0.5rem;
          @media screen and (min-width: $lm-breakpoint-sm-min) {
            margin-bottom: unset;
          }
        }
        #associatesInOffice {
          display: block;
          position: relative;
          top: -6rem;
          visibility: hidden;
        }
      `}</style>
      </div >
    </WrapperSizeable>);
};

AssociateCards.propTypes = {
  associates: PropTypes.arrayOf(PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phones: PropTypes.shape({
      primary: PropTypes.shape({
        number: PropTypes.string.isRequired
      }),
    }),
    image: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    }),
  })).isRequired,
  state: PropTypes.string.isRequired,
};

export default AssociateCards;
